import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CmsService } from '../../shared/cms.service';
import { NotificationService } from '../../shared/notification.service';
import { PrincipalService } from '../../shared/principal.service';

@Component({
  selector: 'app-notification-dialog',
  templateUrl: './notification-dialog.component.html',
  styleUrls: ['./notification-dialog.component.css']
})
export class NotificationDialogComponent implements OnInit {
  isLoading: boolean;
  notification: any;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private notificationService: NotificationService,
    private principal: PrincipalService,
    private cmsService: CmsService
  ) { }

  ngOnInit(): void {
    if (!this.data.dateOpened) {
      this.notificationService.markNotificationRead(this.data.notificationId, this.principal.id).subscribe();
    }

    this.isLoading = true;

    this.notification = {
      notificationBody: `
      <p>Dear Dealer Partner,</p>
      <p>Thank you for your continued support and patience as we work to fully restore connectivity to the ZOOM portal following this outage.</p>
      <p>We're excited to share that key functions are back online, including the ability to quote, submit, and remit contracts. Most reports and QuickTrack have also been restored.</p>
      <p><b>Please take note that before you start quoting and contracting, we ask that you take a moment to review your dealership's settings to ensure your default markups are correctly applied.</b> This is an
      important step to ensure you have the ability to quote accurately.</p>
      <p>We appreciate your ongoing partnership and patience as we bring everything back to full operation.</p>
      <p>Thank you for standing with us!</p>
 `
    }

    this.isLoading = false;


    // this.cmsService.getNotification(this.data.cmsNotificationId).subscribe({
    //   next: (res) => {
    //     this.isLoading = false;
    //     this.notification = res.data.zoomNotifications[0];
    //     console.log(this.notification);
    //   },
    //   error: (err) => {
    //     this.isLoading = false;
    //   }
    // });
  }

}
